import { Alert, message, Space } from 'antd';
import { LinkButton } from 'components/styled/buttons';
import useModal from 'hooks/useModal';
import { isNil } from 'lodash-es';
import { useTranslate } from '@tolgee/react';
import {
  appendRoleReceptionStores,
  AppendRoleReceptionStoresBody,
} from 'services/api/department/roleWithDepartment';
import { errorToasterWithServerMsg } from 'utils/errorToaster';
import groupByTs from 'utils/groupByTs';
import { useNoReceptionStoreOfDept } from '../../hooks/data';
import AssignReceptionModal from './AssignReceptionModal';
import { useRequest } from 'ahooks';
import { getIsAllRoleNoAccount } from 'services/api/department/department';

export interface NoReceptionStoresAlertProps {
  departmentId: StoreHomeV2.Department['id'];
}

const AlertBar = (props: NoReceptionStoresAlertProps) => {
  const { departmentId } = props;
  const { t } = useTranslate();

  const { data: stores, error } = useNoReceptionStoreOfDept(departmentId);
  const configModal = useModal();
  if (error || !stores || stores.length < 1) {
    return null;
  }
  return (
    <>
      <Alert
        type="warning"
        showIcon
        banner
        message={
          <Space size={8} align="center">
            {t('department.部门下有x间店铺未配置参与咨询分配的角色，请尽快进行配置', {
              x: stores?.length,
            })}
            <LinkButton onClick={() => configModal.show()} type="link">
              {t('remind.去配置')}&gt;
            </LinkButton>
          </Space>
        }
      />
      {!isNil(departmentId) ? (
        <AssignReceptionModal
          key={departmentId}
          title={t('department.配置咨询分配')}
          onCancel={() => configModal.hide()}
          visible={configModal.visible}
          departmentId={departmentId}
          onFinish={(values) => {
            const grouped = groupByTs(values.stores ?? [], 'externalType');
            const body: AppendRoleReceptionStoresBody = {
              roleIds: values.roleIds,
              platformStores: Object.keys(grouped).reduce((res, key) => {
                const stores = grouped[key];
                if (!stores || stores.length < 1) {
                  return res;
                }
                res.push({
                  platform: key,
                  storeIds: stores.map((s) => s.id),
                });
                return res;
              }, [] as unknown as AppendRoleReceptionStoresBody['platformStores']),
            };
            appendRoleReceptionStores(body)
              .then(() => {
                message.success(t('operation.saveSucceed'));
                configModal.hide();
              })
              .catch((e) => {
                errorToasterWithServerMsg(e);
              });
          }}
        />
      ) : null}
    </>
  );
};

export const NoReceptionStoresAlert = (props: NoReceptionStoresAlertProps) => {
  const { departmentId } = props;
  /**
   * TB: https://www.teambition.com/task/6603f8693b30810d371f6169
   * 当部门下分配模式为[智能分配]的所有角色，都未绑定账号时，不提示配置咨询分配。
   */
  const { data, loading } = useRequest(() => getIsAllRoleNoAccount(`${departmentId}`), {
    refreshDeps: [departmentId],
  });

  if (loading) return null;

  return data ? null : <AlertBar {...props} />;
};
